module.exports = "/img/_/_/_/assets/images/creeper/battle/common//35.jpg?97d35cd4571c63a35ba72bdda8258819";